import { PATHS } from '../config';
import { Organization } from '../DepartmentService';
import { dynoapeAPI, rawDynoape } from '../dynoape';
import type {
    CountryRules,
    ExternalOrganizationsResponse,
    OrgLicense,
    OrganizationsResponse,
    UpdateOrganizationRequest,
} from './Models';

const getOrganizations = async (): Promise<OrganizationsResponse> =>
    await dynoapeAPI.get(PATHS.organizations);

const getOrganization = async (orgId: string): Promise<Organization> =>
    await dynoapeAPI.get(PATHS.organization(orgId));

const updateOrganization = async (
    orgId: string,
    organization: UpdateOrganizationRequest,
): Promise<Organization> =>
    await dynoapeAPI.put(PATHS.organization(orgId), organization);

const getExternalOrganizations =
    async (): Promise<ExternalOrganizationsResponse> =>
        await dynoapeAPI.get(PATHS.userExternalOrganizations);

const getCountryRules = async (): Promise<CountryRules[]> =>
    await dynoapeAPI.get(PATHS.countryRules);

/*
 * The org license endpoint answers with a non-2xx status when the
 * organization has no license; treat anything but 200 as "no license".
 */
const getOrgLicense = async (
    orgId: string,
): Promise<OrgLicense | undefined> => {
    try {
        const response = await rawDynoape.get(PATHS.orgLicense(orgId));
        return response.status === 200 ? response.data.body : undefined;
    } catch {
        return undefined;
    }
};

const OrganizationService = {
    getOrganization,
    getOrganizations,
    updateOrganization,
    getExternalOrganizations,
    getCountryRules,
    getOrgLicense,
};

export default OrganizationService;
